import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=0f734925&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=0f734925&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f734925",
  null
  
)

export default component.exports